export default "__VITE_ASSET__DPjSKuB0__"